import { FC } from 'react';
import classNames from 'classnames';
import { ButtonOutlinePrimary, ButtonProps, ColorIcon } from '@lambdacurry/component-library';
import { googleAuthURL } from '../../../../util/constants';
import './google-auth-button.scss';

export interface GoogleAuthButtonProps extends ButtonProps {
  redirect: string;
}

export const GoogleAuthButton: FC<GoogleAuthButtonProps> = ({ className, children, redirect, ...props }) => {
  const googleAuthLink = googleAuthURL(redirect);

  return (
    <ButtonOutlinePrimary
      className={classNames('google-auth-button text-sm relative', className)}
      {...props}
      as={buttonProps => (
        <a href={googleAuthLink} {...buttonProps}>
          <span className="flex items-center relative gap-2">
            <ColorIcon name="google" className="-ml-4 lg:ml-0" /> {children}
          </span>
        </a>
      )}
    />
  );
};
